import { useState } from 'react';
import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import FormikInput from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';

const ApiKeyField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.apiKey && touched.apiKey}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    API Key <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Field
                    as={FormikInput}
                    id="apiKey"
                    name="apiKey"
                    type="password"
                    placeholder="Enter API key"
                    maxLength={255}
                    data-walkthroughid={walkthroughIds.createMode.ufApiKeyInput}
                    error={errors.apiKey}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter the API key for this service provider."
                        ariaLabel="service-provider-api-key-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ApiKeyField;
